import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useTranslation} from "react-i18next";
import Table from '../../../components/tables/Table';
import useCustomTable from '../../../components/tables/useCustomTable';
import Block from "../../../components/Block";
import {useGetPublisherUsersQuery} from "../../../api/publisherUserApiSlice";
import Title from "../../../components/Title";
import {TableSearchRow} from "../../../components/tables/TableSearch";

export default function PublisherUsers(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { publisherId } = useParams();
  const {data: users, isSuccess} = useGetPublisherUsersQuery(publisherId)

  const columns = [{
      Header: 'First name',
      accessor: 'firstName',
    },{
      Header: 'Last name',
      accessor: 'lastName',
    },{
      Header: 'Email',
      accessor: 'email'
    }, {
      Header: t('users.createdAt'),
      accessor: 'createdAt',
      format: 'date',
    }, {
      Header: t('users.lastConnection'),
      accessor: 'currentSignInAt',
      format: 'date'
    }
  ]

  const tableOptions = {
    sortable: true,
    filterable: true,
    paginate: false
  }

  const {
    tableProps,
    tableSearchProps
  } = useCustomTable(tableOptions)

  const showUser = (user) => history.push(`/users/${user.slug}`)

  const onBack = () => history.push(`/publishers/${publisherId}`)

  if ( !isSuccess ) { return (<></>) }

  return (
    <>
      <Title main={t("menu.users")} onBack={onBack}/>
      <TableSearchRow {...tableSearchProps}/>
      <Block>
        <Table data={users} columns={columns} onRowClick={showUser} {...tableOptions} {...tableProps}/>
      </Block>
    </>
  )
}




